export default __webpack_public_path__ + "static/media/nursery-benefit.c944026c.png";